import { onDomReady } from "../../utils/on-dom-ready";
import { handleSearch } from "./faq-search-handler";
import { ResultIndicator } from "./faq-search-result-indicator";

const initializeResultIndicator = () => {
  const indicatorOverlay = document.querySelector<HTMLElement>(
    ".faq-search__actions-wrapper"
  );
  const previousResultButton = document.querySelector<HTMLButtonElement>(
    ".faq-search__arrow--previous"
  );
  const nextResultButton = document.querySelector<HTMLButtonElement>(
    ".faq-search__arrow--next"
  );
  const resultPositionIndicator = document.querySelector<HTMLElement>(
    ".faq-search__indicator"
  );
  const header = document.querySelector<HTMLElement>(".js-navbar");
  return new ResultIndicator(
    indicatorOverlay,
    previousResultButton,
    nextResultButton,
    resultPositionIndicator,
    header
  );
};

/**
 * Register event handlers to trigger the search of a collection
 */
const registerEventHandlers = () => {
  const resultIndicator = initializeResultIndicator();

  const searchFields = document.getElementsByClassName("faq-search");

  for (const searchField of searchFields) {
    const searchInput = searchField.querySelector<HTMLInputElement>(
      ".faq-search__input-field"
    );
    const searchButton = searchField.querySelector(".faq-search__button");

    // Event handler on enter for search bar
    searchInput?.addEventListener("keypress", (event) => {
      if (event.key === "Enter") {
        handleSearch(searchInput?.value || "", resultIndicator);
      }
    });

    // Event handler on click for search button
    searchButton?.addEventListener("click", () => {
      handleSearch(searchInput?.value || "", resultIndicator);
    });
  }
};

// Register event handlers on page load
onDomReady(registerEventHandlers);
